import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { MomentModule } from 'angular2-moment';

import { UsersSiteRoutingModule } from './users-routing.module';
import { UsersSiteComponent } from './components/scripts/usersSite.component';
import { UsersSiteFilterComponent } from './components/scripts/usersSiteFilter.component';
import { AuthorFollowsService } from './services/authorFollows.service';
import { UserDeleteService } from './services/userDelete.service';
import { EventFollowsService } from './services/eventFollows.service';
import { UserNewslettersService } from './services/userNewsletters.service';
import { AuthorService } from '../shared/services/author.service';
import { NewsletterTypesService } from './services/newsletterTypes.service';
import { PaymentTransactionsService } from './services/paymentTransactions.service';
import { PostService } from '../shared/services/post.service';
import { DeleteUserModalComponent } from './components/scripts/deleteUserModal.component';
import { UserSettingsService } from './services/userSettings.service';
import { LeadsService } from './services/leads.service';
import { TransactionModalComponent } from './components/scripts/transactionModal.component';
import { CalendarService } from '../shared/services/calendar.service';
import { CalendarBOService } from '../shared/services/calendarBO.service';
import { UsersSiteService } from '../shared/services/usersSite.service';
import { DiscordService } from './services/discordService.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UsersSiteRoutingModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    MomentModule
  ],
  declarations: [
    UsersSiteFilterComponent,
    UsersSiteComponent,
    DeleteUserModalComponent,
    TransactionModalComponent
  ],
  providers: [
    UsersSiteService,
    AuthorFollowsService,
    EventFollowsService,
    UserNewslettersService,
    AuthorService,
    PostService,
    CalendarService,
    CalendarBOService,
    NewsletterTypesService,
    PaymentTransactionsService,
    UserSettingsService,
    UserDeleteService,
    LeadsService,
    DiscordService,
  ],
  entryComponents: [DeleteUserModalComponent, TransactionModalComponent]
})

export class UsersSiteModule { }



// WEBPACK FOOTER //
// ./src/app/users/usersSite.module.ts